
import HousingCompanyDetailsTabs from "components/housingCompany/details/HousingCompanyDetailsTabs";
import LtvAnalysisLayout from "components/housingCompany/details/LtvAnalysis/LtvAnalysis";
import AdminLayout from "components/layouts/AdminLayout";

function LtvAnalysis(props: any) {
    const selectedTab = 2;
    return (
        <>
            <AdminLayout>
                <LtvAnalysisLayout props={props} selectedTab={selectedTab}/>
                <HousingCompanyDetailsTabs props={props} selectedTab={4} />
            </AdminLayout>
        </>
    );
}

export default LtvAnalysis;